<template>
  <div class="add-advert-group">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="dialogType === 'add' ? $t('cAdvertPiano.createPiano') : $t('cAdvertPiano.editPiano')"
      :visible.sync="showPianoDialog"
      width="60%"
      top="9vh"
      :close-on-click-modal="false"
      @open="handleOpen"
      @close="cancel"
    >
      <div>
        <el-form
          :model="formData"
          :rules="rules"
          label-position="top"
          ref="formRef"
          hide-required-asterisk
          :disabled="!hasPerEdit"
        >
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item :label="$t('cAdvertPiano.name')" prop="name">
                <el-input v-model="formData.name" :placeholder="$t('cAdvertPiano.searchJh')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('cAdvertPiano.sort')" prop="sort">
                <el-input-number
                  v-model="formData.sort"
                  :placeholder="$t('cAdvertPiano.searchPx')"
                  step-strictly
                  controls-position="right"
                  style="width: 100%"
                  :min="0"
                />
              </el-form-item>
            </el-col>
            <el-col>
              <el-tabs v-model="tabs.activeName" @tab-click="handleClick">
                <!-- 播放设置 -->
                <el-tab-pane :label="$t('cAdvertPiano.setPlay')" name="play">
                  <el-col>
                    <el-form-item :label="$t('cAdvertPiano.putIn')" prop="playNum">
                      <el-input :placeholder="$t('desktop.launchNum')" v-model="formData.playNum" type="number">
                        <template slot="append">{{ $t("cAdvertPiano.numByDay") }}</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('cAdvertPiano.promozioneDate')" prop="playTime">
                      <el-date-picker
                        v-model="formData.playTime"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        unlink-panels
                        :start-placeholder="$t('components.Insert.9398966-57')"
                        :end-placeholder="$t('components.Insert.9398966-58')"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col style="margin-bottom: 10px">
                    <AdvertWeek v-model="formData.config.time" ref="weekRef" />
                  </el-col>
                  <div style="color: brown">{{ $t("cAdvertPiano.tip") }}</div>
                </el-tab-pane>

                <!-- 播放内容 -->
                <el-tab-pane :label="$t('cAdvertPiano.content')" name="content">
                  <el-col :span="12" v-if="dialogType != 'add'">
                    <el-form-item :label="$t('adverput.sftj')">
                      <el-select
                        v-model="searchParams.type"
                        :placeholder="$t('cAdvertPiano.putInTip')"
                        clearable
                        @change="handleCurrentChange(1)"
                      >
                        <el-option v-for="item in advertOptions.add" v-bind="item" :key="item.value" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('cAdvertPiano.showPosition')">
                      <el-select
                        v-model="searchParams.display"
                        :placeholder="$t('cAdvertPiano.putInTip')"
                        clearable
                        @change="handleCurrentChange(1)"
                      >
                        <el-option v-for="item in advertOptions.display" v-bind="item" :key="item.value" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-table
                      :data="advertsList"
                      style="width: 100%"
                      row-key="id"
                      ref="advertListRef"
                      @selection-change="handleSelectionChange"
                    >
                      <el-table-column type="selection" width="55" reserve-selection :selectable="isRowSelectable" />
                      <el-table-column :label="$t('cAdvertPiano.showPosition')" prop="display">
                        <template #default="{ row }">
                          <span>
                            {{ row.display == "1" ? $t("cAdvertPiano.display-1") : $t("cAdvertPiano.display-2") }}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('cAdvertPiano.showContent')" prop="url" width="180" align="center">
                        <template #default="{ row }">
                          <el-image
                            :src="row.url"
                            fit="scale-down"
                            style="height: 80px; width: 180px"
                            v-if="row.type == 0"
                          ></el-image>
                          <video-player
                            v-if="row.type == 1"
                            class="video-player-box vjs-custom-skin"
                            ref="videoPlayer"
                            :options="getVideoOptions(row)"
                            :playsinline="true"
                          >
                          </video-player>
                          <div
                            v-else-if="row.type == 2"
                            class="image web-ad-preview"
                            @click.stop="openUrl(row.url)"
                            :title="$t('addAdverts.clickToLink')"
                          >
                            <div class="web-ad-content">
                              <i class="el-icon-link"></i>
                              <div class="url-text">{{ row.url }}</div>
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('cAdvertPiano.pianoTitle')" prop="head" />
                      <el-table-column :label="$t('components.Add.800967-15')" prop="startTime" />
                      <el-table-column :label="$t('components.Add.800967-16')" prop="endTime" />
                    </el-table>
                    <div class="table-footer">
                      <el-button type="danger" size="small" @click="clearAdvertsSelection">
                        {{ $t("components.MachineConfig.9398863-7") }}
                      </el-button>
                      <el-pagination
                        style="margin-top: 0px; text-align: right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                      ></el-pagination>
                    </div>
                  </el-col>
                </el-tab-pane>
                <!-- 播放设备 -->
                <el-tab-pane :label="$t('cAdvertPiano.facility')" name="facility">
                  <AddEquipment v-model="formData.equipmentIds" v-if="showPianoDialog" />
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm" @click="submitForm('advertGroup')">{{
          $t("common.definite")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { checkPerm } from "@/utils/permission";
  import AdvertWeek from "@/components/adverts/AdvertWeek.vue";
  import AddEquipment from "@/components/adverts/AddEquipment.vue";
  import "video.js/dist/video-js.css";

  import { videoPlayer } from "vue-video-player";

  export default {
    name: "AddAdvertGroup",
    props: {
      showPianoDialog: {
        type: Boolean,
        default: false
      }
    },
    components: {
      AdvertWeek,
      AddEquipment,
      videoPlayer
    },
    data() {
      return {
        formData: {
          config: {
            time: []
          }
        },
        selectedTypeByDisplay: {},
        rules: {
          name: [
            {
              required: true,
              message: this.$t("cAdvertPiano.searchJh"),
              trigger: "blur"
            }
          ],
          sort: [
            {
              required: true,
              message: this.$t("cAdvertPiano.searchPx"),
              trigger: "blur"
            }
          ],
          playNum: [
            {
              required: true,
              message: this.$t("cAdvertPiano.RuleTip", [this.$t("cAdvertPiano.putIn")]),
              trigger: "blur"
            }
          ],
          playTime: [
            {
              required: true,
              message: this.$t("cAdvertPiano.RuleTip", [this.$t("cAdvertPiano.promozioneDate")]),
              // 自定义校验器：同时校验「非空」和「日期范围合法性」
              validator: (rule, value, callback) => {
                if (!value || value.length < 2) {
                  callback(new Error(this.$t("cAdvertPiano.RuleTip", [this.$t("cAdvertPiano.promozioneDate")])));
                  return; // 提前结束，避免后续校验
                }
                callback();
              },
              trigger: "change" // 日期选择器用 change 触发校验
            }
          ],
          adIds: [
            {
              required: true,
              message: this.$t("cAdvertPiano.RuleTip", [this.$t("cAdvertPiano.content")]),
              validator: (rule, value, callback) => {
                if (value.length === 0) {
                  callback(new Error(this.$t("cAdvertPiano.RuleTip", [this.$t("cAdvertPiano.facility")])));
                } else {
                  callback();
                }
              },
              trigger: "blur"
            }
          ],
          equipmentIds: [
            {
              required: true,
              message: this.$t("cAdvertPiano.RuleTip", [this.$t("cAdvertPiano.facility")]),
              validator: (rule, value, callback) => {
                if (value.length === 0) {
                  callback(new Error(this.$t("cAdvertPiano.RuleTip", [this.$t("cAdvertPiano.facility")])));
                } else {
                  callback();
                }
              },
              trigger: "blur"
            }
          ]
        },
        teledataData: [],
        advertsList: [],
        equipmentList: [],
        tabs: {
          activeName: "play"
        },
        advertOptions: {
          display: [
            { label: this.$t("cAdvertPiano.display-1"), value: "1" },
            { label: this.$t("cAdvertPiano.display-2"), value: "2" }
          ],
          add: [
            {
              label: this.$t("cAdvertPiano.add-1"),
              value: "1"
            },
            {
              label: this.$t("cAdvertPiano.add-0"),
              value: "0"
            }
          ]
        },
        currentPage: 1,
        pageSize: 10,
        total: 0,
        searchParams: {
          display: "",
          type: ""
        },
        dialogType: "add"
      };
    },
    computed: {
      hasPerEdit() {
        if (this.dialogType === "add") {
          return true;
        }
        return checkPerm(["advert:piano:edit"]);
      }
    },
    methods: {
      beforeOpen(data) {
        if (!data) {
          this.formData = {};
          return;
        }
        const detail = JSON.parse(JSON.stringify(data));
        this.formData = detail;
        this.formData.playTime = [detail.startDate, detail.endDate];
        if (this.formData.config.time.length === 0) {
          this.$nextTick(() => {
            this.$refs.weekRef?.onToggleAll(true);
          });
        }
        this.teledata = [...this.formData.adIds];
        this.dialogType = "edit";
      },
      handleOpen() {
        this.getAdvertsList();
      },
      resetDialog() {
        this.pageSize = 10;
        this.currentPage = 1;
        this.total = 0;
        this.tabs.activeName = "play";
        this.dialogType = "add";

        this.searchParams.display = "";
        this.searchParams.type = "";
        this.$refs.formRef?.resetFields();
        if (this.$refs.advertListRef) {
          this.$refs.advertListRef.clearSelection();
        }
        this.selectedTypeByDisplay = {};
      },
      getAdvertsList() {
        this.$api
          .request(this.$url.AdvertsPiano.advert, this.$method.get, {
            adPlanId: this.formData?.id,
            pageIndex: this.currentPage,
            pageSize: this.pageSize,
            display: this.searchParams.display,
            type: this.searchParams.type
          })
          .then(res => {
            if (res.code === 0) {
              this.advertsList = res.data.records;
              this.total = Number(res.data.total);
              this.$nextTick(() => {
                this.restoreSelection();
              });
            }
          });
      },
      restoreSelection() {
        if (!this.$refs.advertListRef || !this.formData.adIds) return;
        this.selectedTypeByDisplay = {};
        const adIdSet = new Set(this.formData.adIds);
        this.advertsList.forEach(row => {
          if (adIdSet.has(row.id)) {
            this.$refs.advertListRef.toggleRowSelection(row, true);
          }
        });
      },
      handleSelectionChange(selection) {
        const selArr = Array.isArray(selection) ? selection : selection ? [selection] : [];
        const typeByDisplay = {};
        const allowed = [];
        const toDeselect = [];

        selArr.forEach(item => {
          const displayKey = String(item.display ?? "");
          const itemType = item.type;
          if (!(displayKey in typeByDisplay)) {
            typeByDisplay[displayKey] = itemType;
            allowed.push(item);
            return;
          }
          if (typeByDisplay[displayKey] === itemType) {
            allowed.push(item);
            return;
          }
          toDeselect.push(item);
        });

        this.selectedTypeByDisplay = typeByDisplay;
        this.formData.adIds = allowed.map(item => item.id);

        if (this.$refs.advertListRef) {
          toDeselect.forEach(item => {
            this.$refs.advertListRef.toggleRowSelection(item, false);
          });
        }
      },
      clearAdvertsSelection() {
        this.formData.adIds = [];
        if (this.$refs.advertListRef) {
          this.$refs.advertListRef.clearSelection();
        }
        this.selectedTypeByDisplay = {};
      },
      handleSizeChange(newSize) {
        this.pageSize = newSize;
        this.currentPage = 1;
        this.getAdvertsList();
      },
      handleCurrentChange(newPage) {
        this.currentPage = newPage;
        this.getAdvertsList();
      },
      cancel() {
        this.formData = {
          config: {
            time: []
          }
        };
        this.resetDialog();
        this.$emit("cancel");
      },

      async submitForm() {
        console.log(this.hasPerEdit);
        if (!this.hasPerEdit) {
          this.cancel();
          return;
        }
        const url = this.dialogType === "add" ? this.$url.AdvertsPiano.insert : this.$url.AdvertsPiano.update;
        const method = this.dialogType === "add" ? this.$method.post : this.$method.put;
        const that = this;
        await this.$refs.formRef?.validate((isValid, errorFields) => {
          console.log(isValid, errorFields);
          if (isValid) {
            const params = JSON.parse(JSON.stringify(this.formData));
            if (params.playTime) {
              params.startDate = params.playTime[0];
              params.endDate = params.playTime[1];
              delete params.playTime;
            }
            if (params.config.time.length === 0) {
              that.$message({
                message: that.$t("cAdvertPiano.RuleTip", [that.$t("cAdvertPiano.weekTip")]),
                type: "warning"
              });
              return;
            }
            if (params.config.time.length === 168) {
              params.config.time = [];
            }
            if (params)
              this.$api.request(url, method, params).then(res => {
                if (res.code === 0) {
                  that.$message({
                    message: this.$t("common.success"),
                    type: "success"
                  });
                  this.$emit("submit");
                  this.cancel();
                }
              });
          } else {
            if (errorFields?.[0]) {
              that.$message({
                message: errorFields[0]?.message,
                type: "warning"
              });
            }
          }
        });
      },
      getVideoOptions(item) {
        let videoUrl = item.url || item.showVideo;
        if (!videoUrl) {
          for (const key in item) {
            const val = item[key];
            if (
              typeof val === "string" &&
              val.startsWith("http") &&
              (val.match(/\.(mp4|m4v|mov|webm)$/) || val.includes("video"))
            ) {
              videoUrl = val;
              break;
            }
          }
        }
        return {
          autoplay: false,
          muted: true,
          loop: false,
          preload: "auto",
          language: "zh-CN",
          aspectRatio: "16:9",
          fluid: true,
          sources: [
            {
              type: "video/mp4",
              src: videoUrl
            }
          ],
          notSupportedMessage: this.$t("common.noData"),
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true
          }
        };
      },
      openUrl(url) {
        if (url) {
          const fullUrl = url.indexOf("http") === 0 ? url : "https://" + url;
          window.open(fullUrl, "_blank");
        }
      },
      isRowSelectable(row) {
        const displayKey = String(row?.display ?? "");
        if (!this.selectedTypeByDisplay || Object.keys(this.selectedTypeByDisplay).length === 0) {
          return true;
        }
        if (!(displayKey in this.selectedTypeByDisplay)) {
          return true;
        }
        return row.type === this.selectedTypeByDisplay[displayKey];
      }
    }
  };
</script>

<style scoped lang="scss">
  .table-footer {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .video-player-box {
    width: 180px;
    height: 120px;
    :deep(.video-js) {
      .vjs-big-play-button {
        font-size: 1em;
        position: absolute !important;
        left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;
      }
    }
  }
  .web-ad-preview {
    cursor: pointer;
  }
</style>
